import React, { FC } from "react";
import "./ChatImage.scss";

interface Props {
    readonly imageUrl: string;
    readonly imageActionUrl?: string;
}

const ChatImage: FC<Props> = props => {
    const cleanUrl = props.imageUrl.replace(/'/g, "%27");
    const content = <div className="chat-card-img__content"
        style={{ backgroundImage: `url(${cleanUrl})` }}
    />;
    if (!props.imageActionUrl) {
        return (
            <div className="chat-card-img">
                { content}
            </div>);
    } else {
        return (
            <a href={props.imageActionUrl} aria-label="read more" target="_blank" rel="noopener noreferrer" className="chat-card-img">
                {content}
            </a>
        );
    }
}

export default ChatImage;